var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollara(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5222ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140.101 -140.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.478,314.893h-5.789a2.238,2.238,0,0,1,0-4.475h5.437a.452.452,0,1,0,0-.9H334.6v-2.556a.452.452,0,0,0-.9,0v2.556h-2.007a3.141,3.141,0,0,0,0,6.282h5.789a2.238,2.238,0,0,1,0,4.477h-5.438a.452.452,0,0,0,0,.9H333.7v2.555a.452.452,0,1,0,.9,0v-2.555h2.878a3.142,3.142,0,0,0,0-6.283Z",
    transform: "translate(-164.484 -145.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M285.514,272.34A13.184,13.184,0,1,0,298.7,285.524,13.2,13.2,0,0,0,285.514,272.34Zm0,25.463a12.28,12.28,0,1,1,12.28-12.28A12.293,12.293,0,0,1,285.514,297.8Z",
    transform: "translate(-115.414 -115.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M199.649,169.643h-4.877a24.7,24.7,0,0,0-24.219-24.219v-4.878a.452.452,0,0,0-.9,0v4.878a24.7,24.7,0,0,0-24.219,24.219h-4.878a.452.452,0,0,0,0,.9h4.878a24.7,24.7,0,0,0,24.219,24.219v4.877a.452.452,0,1,0,.9,0v-4.877a24.7,24.7,0,0,0,24.219-24.219h4.877a.452.452,0,0,0,0-.9Zm-29.1,24.219v-4.855a.452.452,0,1,0-.9,0v4.855a23.8,23.8,0,0,1-23.315-23.315h4.855a.452.452,0,0,0,0-.9h-4.855a23.8,23.8,0,0,1,23.315-23.315v4.855a.452.452,0,0,0,.9,0v-4.855a23.8,23.8,0,0,1,23.317,23.315h-4.855a.452.452,0,0,0,0,.9h4.855a23.8,23.8,0,0,1-23.315,23.315Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollara);
export default __webpack_public_path__ + "static/media/Dollara.77a86a55c8376587b0419d1c21279088.svg";
export { ForwardRef as ReactComponent };